import { JbCart, JbCartItem } from '@jbhi-fi/apis/src/shopify/types/JbCart';

type JbCartItemWithParentId = JbCartItem & Required<Pick<JbCartItem, 'parent_line_id'>>;

export const getMigratedLegacyNestedCartLines = (cart: JbCart): Array<JbCartItemWithParentId> => {
  const migratedCartItems = cart.items
    .filter(item => item.properties._legacy_addons_primary_line_key && !item.parent_line_id)
    .map(item => {
      const parentId = cart.items.find(
        i => i.properties._legacy_addons_line_key === item.properties._legacy_addons_primary_line_key
      )?.line_id;

      if (!parentId) return undefined;

      const { _legacy_addons_primary_line_key, _legacy_addons_line_key, ...propertiesWithoutLegacy } = item.properties;

      return {
        ...item,
        properties: propertiesWithoutLegacy,
        parent_line_id: parentId,
      } as JbCartItemWithParentId;
    })
    .filter(item => item);

  return migratedCartItems;
};
